import getLocationType from '../actions/getLocationType';

const typeToClassMap = {
  country: 'country-name',
  group: 'group-name',
  'custom-group': 'custom-group-name',
};

export const resolveLocationNameType = ({ code, type, kind }) => {
  if (type) return type;
  if (kind) return kind;
  if (code) return getLocationType(code);
  return 'country';
};

export const buildLocationNameClasses = ({ code, type, kind, className = '' }) => {
  const resolvedType = resolveLocationNameType({ code, type, kind });
  const typeClass = typeToClassMap[resolvedType] || '';
  return ['location-name', typeClass, className].filter(Boolean).join(' ');
};

export default {
  typeToClassMap,
  resolveLocationNameType,
  buildLocationNameClasses,
};
